module.exports = __webpack_public_path__ + "assets/img/1402.568a19b0.svg";